/*
  Pre-order detection for Shopify Bundles (fixed bundles made with the Shopify Bundles app).

  Liquid cannot see a bundle's components, and Shopify leaves any component set to "continue selling
  when out of stock" out of the bundle's inventory calculation — so a bundle holding such a component
  still renders as in stock, and the Liquid pre-order check never fires for it. The Storefront API does
  expose the components (tokenless), along with currentlyNotInStock: out of stock but still for sale.

  lookup(handle) resolves to the ids of the bundle variants that should read as pre-order. It never
  rejects: on any failure it resolves to an empty set, which leaves the page as Liquid rendered it.
  Out-of-stock components that are *not* for sale need nothing here — they drop the bundle's inventory
  to zero, so Liquid already renders it sold out.
*/
window.VCC = window.VCC || {};

window.VCC.bundlePreorder = window.VCC.bundlePreorder || {
  endpoint: '/api/2025-07/graphql.json',
  cache: new Map(),

  query: `query BundlePreorder($handle: String!) {
    product(handle: $handle) {
      variants(first: 100) {
        nodes {
          id
          availableForSale
          requiresComponents
          components(first: 30) {
            nodes {
              productVariant {
                currentlyNotInStock
              }
            }
          }
        }
      }
    }
  }`,

  lookup(handle) {
    if (!handle || !window.FoxTheme?.settings?.preorderEnabled) return Promise.resolve(new Set());
    if (!this.cache.has(handle)) this.cache.set(handle, this.fetchPreorderVariants(handle));
    return this.cache.get(handle);
  },

  fetchPreorderVariants(handle) {
    return fetch(this.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: this.query, variables: { handle } }),
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error(response.status))))
      .then(({ data }) => {
        const variants = data?.product?.variants?.nodes || [];
        const ids = variants
          .filter(
            (variant) =>
              variant.requiresComponents &&
              variant.availableForSale &&
              variant.components?.nodes?.some((component) => component.productVariant?.currentlyNotInStock)
          )
          .map((variant) => Number(variant.id.split('/').pop()));
        return new Set(ids);
      })
      .catch((error) => {
        console.error('Bundle pre-order lookup failed:', error);
        return new Set();
      });
  },
};

// Quick view re-injects its script tags, which then run async rather than in defer order, so
// product-info can connect before this file has run. It waits for this event in that case.
document.dispatchEvent(new CustomEvent('vcc:bundle-preorder:ready'));
